module.exports = __webpack_public_path__ + "static/media/87.98d27b37.png";